<a [customRouterLink]="'/'">
  <span *ngIf="baseSite$ | async as baseSite">
    {{ baseSite.name }}
  </span>
</a>
